/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import {
    BreadcrumbsDispatcher as SourceBreadcrumbsDispatcher
} from 'SourceStore/Breadcrumbs/Breadcrumbs.dispatcher';

/**
 * Breadcrumbs Dispatcher
 * @class BreadcrumbsDispatcher
 * @namespace Scandipwa/Store/Breadcrumbs/Dispatcher */
export class BreadcrumbsDispatcher extends SourceBreadcrumbsDispatcher {
    _getProductBreadcrumbs(product, prevCategoryId = null) {
        const { categories, url, name } = product;

        if (!categories || !categories.length) {
            return [];
        }

        return [
            { url, name },
            ...this._getCategoryBreadcrumbs(
                this.findCategoryById(categories, prevCategoryId)
                || this.findLongestBreadcrumbs(categories)
            )
        ];
    }

    _getCategoryBreadcrumbs(category) {
        const {
            url,
            name,
            breadcrumbs,
            id
        } = category;
        const breadcrumbsList = [];

        if (breadcrumbs) {
            breadcrumbs
                .sort((a, b) => a.category_level - b.category_level)
                .forEach((crumb) => {
                    const {
                        category_url, category_name, category_is_active, category_id
                    } = crumb;

                    // do not add link to inactive categories
                    if (category_is_active) {
                        breadcrumbsList.push({
                            name: category_name,
                            url: {
                                pathname: category_url,
                                state: { category: true }
                            },
                            category_id
                        });
                    } else {
                        breadcrumbsList.push({
                            url: '',
                            name: category_name
                        });
                    }
                });
        }

        return [
            { url, name, category_id: id },
            ...breadcrumbsList.reverse()
        ];
    }
}

export default new BreadcrumbsDispatcher();
